'use client'

import {
  HeaderAccount,
  HeaderAction,
  HeaderActions,
  HeaderBrand,
  HeaderRoot,
  HeaderSearchAction,
} from '@dafiti/closet-ui'
import { Coupon } from '@dafiti/closet-ui/icons'
import { isCountryFeatureEnabled } from '@dafiti/feature-flag-sdk'
import { useEnvContext } from 'next-runtime-env'

import { useAppLayoutContext } from '../../../providers/AppLayoutProvider'
import { useMessages } from '../../../i18n/useMessages'
import * as track from '../../../tracking/header'
import { Search } from '../Search/Search'
import MenuToggle from './MenuToggle'
import { GreetingText } from './GreetingText'
import WishlistIcon from './Wishlist/WishlistIcon'
import CartIcon from './Cart/CartIcon'
import type { Locale } from '@dafiti/feature-flag-sdk'

export const Base = () => {
  const { options, LinkComponent } = useAppLayoutContext()
  const t = useMessages()
  const { NEXT_PUBLIC_DEFAULT_LOCALE } = useEnvContext() as {
    NEXT_PUBLIC_DEFAULT_LOCALE: Locale
  }

  const { urls } = options

  return (
    <HeaderRoot className="border-b-0 lg:border-b-[1px]" data-testid="header">
      <MenuToggle />

      <HeaderBrand
        ariaLabel={t.header.brandAriaLabel}
        as={LinkComponent}
        href="/"
      />

      <Search />

      <HeaderAccount className="w-[120px] justify-end">
        <GreetingText />
      </HeaderAccount>

      <HeaderActions>
        <HeaderSearchAction
          label={t.header.search}
          ariaLabel={t.header.openSearchAriaLabel}
        />

        {isCountryFeatureEnabled('coupons', NEXT_PUBLIC_DEFAULT_LOCALE) && (
          <HeaderAction
            label={t.header.coupons}
            ariaLabel={t.header.couponsAriaLabel}
            onClick={() => track.couponClick()}
          >
            <LinkComponent href={urls.coupons}>
              <Coupon aria-hidden="true" />
            </LinkComponent>
          </HeaderAction>
        )}

        <WishlistIcon />

        <CartIcon />
      </HeaderActions>
    </HeaderRoot>
  )
}
